import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Rx';

import { HttpClientService } from '../../../shared/services/http-client.service';

@Injectable()
export class TimeReportService {

  constructor(
    private httpClient: HttpClientService
  ) { }
  
  getAttendanceTimeSummary(body:any): Observable<any> {
    return this.httpClient.post('admin/reports/attendance-timesheet-summary', body);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/time/services/time-report.service.ts